enum CopyState {
    SelectCompanies,
    SelectDate,
    ViewResults
}

export default CopyState;
